/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import initialState from 'store/initialState';

export const loyaltyPointsSlice = createSlice({
  name: 'loyaltyPoints',
  initialState: initialState.loyaltyPoints,
  reducers: {
    initPoints: (state) => {
      state.points = {
        data: null,
        error: null,
      };
    },
    successPoints: (state, action) => {
      state.points = {
        data: action.payload,
        error: null,
      };
    },
    errorPoints: (state, action) => {
      state.points = {
        data: null,
        error: action.payload,
      };
    },
    initCoupons: (state) => {
      state.coupons = {
        data: null,
        error: null,
      };
    },
    successCoupons: (state, action) => {
      state.coupons = {
        data: action.payload,
        error: null,
      };
    },
    errorCoupons: (state, action) => {
      state.coupons = {
        data: null,
        error: action.payload,
      };
    },
    initPromotions: (state) => {
      state.promotions = {
        data: null,
        error: null,
      };
    },
    successPromotions: (state, action) => {
      state.promotions = {
        data: action.payload,
        error: null,
      };
    },
    errorPromotions: (state, action) => {
      state.promotions = {
        data: null,
        error: action.payload,
      };
    },
    clear: (state) => {
      state.points = {
        data: null,
        error: null,
      };
      state.coupons = {
        data: null,
        error: null,
      };
      state.promotions = {
        data: null,
        error: null,
      };
    },
  },
});

export const loyaltyPointsActions = loyaltyPointsSlice.actions;

export default loyaltyPointsSlice.reducer;
